// Host-side music themes. Tracks are served from R2 via the public /media/* route
// (keys: audio/<theme>/<phase>.mp3). "none" is the default (silence).
export interface MusicTheme {
  id: string;
  name: string;
  blurb: string;
  lobby?: string;
  question?: string;
  podium?: string;
}

const A = (theme: string, phase: string) => `/media/audio/${theme}/${phase}.mp3`;

export const MUSIC_THEMES: MusicTheme[] = [
  { id: "none", name: "No music", blurb: "Silence — the default." },
  {
    id: "bakery-bounce",
    name: "Bakery Bounce",
    blurb: "Upbeat & playful — light and bouncy.",
    lobby: A("bakery-bounce", "lobby"),
    question: A("bakery-bounce", "question"),
    podium: A("bakery-bounce", "podium"),
  },
  {
    id: "cafe-calm",
    name: "Café Calm",
    blurb: "Relaxed lounge — easy background.",
    lobby: A("cafe-calm", "lobby"),
    question: A("cafe-calm", "question"),
    podium: A("cafe-calm", "podium"),
  },
  {
    id: "showtime",
    name: "Showtime",
    blurb: "Game-show energy — bright and driving.",
    lobby: A("showtime", "lobby"),
    question: A("showtime", "question"),
    podium: A("showtime", "podium"),
  },
];

export const DEFAULT_THEME_ID = "none";

/** Resolve an id to a theme; unknown/null → "No music" (never throws/null). */
export function themeById(id: string | null | undefined): MusicTheme {
  return MUSIC_THEMES.find((t) => t.id === id) ?? MUSIC_THEMES[0];
}

const keyFor = (pin: string) => `bk_music_${pin}`;

/** Persist the host's choice for this PIN (mirrors bk_host_<pin>). No-op for "none". */
export function rememberMusic(pin: string, id: string): void {
  try {
    if (id && id !== DEFAULT_THEME_ID) localStorage.setItem(keyFor(pin), id);
    else localStorage.removeItem(keyFor(pin));
  } catch {
    /* private mode — host just gets no music this session */
  }
}

/** Read back the theme chosen for this PIN (→ "No music" if none/blocked). */
export function musicThemeFor(pin: string): MusicTheme {
  try {
    return themeById(localStorage.getItem(keyFor(pin)));
  } catch {
    return MUSIC_THEMES[0];
  }
}
